import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default, { forwardRef } from 'react';
import classNames from 'classnames';
import styles from './778947f91be5e50ebdfb691e3e7b2ba38c07c4298e845a0da9fb11af3f9a072c.cfe-internal.js';
import '../../components/LoadingSpinner/8d55022eb7dc98c5cad52af9b09720070c60d56c43c0dee35584cf8912401ad4.cfe-internal.js';
import { FLYOUT_POPPER_OFFSET } from '../f5e4d8f62716db08736bdf8cd2bfb32640bfafeca586ef59cc354009b4870444.cfe-internal.js';
import '../Translation/f2111243fb654c449fd688bf450f5354d8950ad7f781ba5a82352da08f838259.cfe-internal.js';
import useTranslation from '../Translation/de13cef5749fcd5a6a2788a56fd20c6a15d546ad2713851a9b628cd5aa481529.cfe-internal.js';
import LoadingSpinner from '../../components/LoadingSpinner/b05dae0bfab7f74e168d22a1b9d6e2b06f09ee65c56c37161ee98465fe504ae4.cfe-internal.js';

var _excluded = ["children", "anchorRef", "className", "isLoading", "style", "id"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var Flyout = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    anchorRef = _ref.anchorRef,
    className = _ref.className,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    style = _ref.style,
    id = _ref.id,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    translate = _useTranslation.translate;
  var content;
  if (isLoading) {
    content = /*#__PURE__*/React__default.createElement("div", {
      id: "".concat(id, "-loading-spinner")
      // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
      ,
      role: "option" // `aria-selected` is omitted because this option is not selectable
    }, /*#__PURE__*/React__default.createElement(LoadingSpinner, {
      "aria-label": translate('loading'),
      className: styles.flyoutSpinner,
      show: true,
      size: "small"
    }));
  } else {
    content = children;
  }
  return /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    id: id,
    className: classNames(className, _defineProperty({}, styles.flyout, !!content)),
    ref: ref,
    role: "listbox",
    style: _objectSpread({
      // This logic is located here instead of DropdownList.js/ComboboxList.js so the maxHeight will update with screen resizing (Popper has a resize listener that causes this to rerender)
      maxHeight: Math.min(350,
      // half of window height - flyout popper offset - half of anchor height (fallback to default 18px)
      document.documentElement.clientHeight / 2 - FLYOUT_POPPER_OFFSET[1] - (anchorRef.current ? anchorRef.current.offsetHeight / 2 : 18))
    }, style)
  }), content);
});

export { Flyout };
